import { Endpoints } from 'utils/endpoints';

export type EditorConfig = {
  height: string;
  placeholderText: string;
  acceptedImageTypes: string[];
  fontSize: string[];
  pasteDeniedTags: string[];
  toolbarContainer: string;
  charCounterCount: boolean;
  quickInsertEnabled: boolean;
  imageUpload: boolean;
  imageMaxSize: number;
  shortcutsEnabled: string[];
  imageUploadURL: string;
  toolbarButtons: string[];
  paragraphFormatSelection: boolean;
  fontFamilySelection: boolean;
  attribution: boolean;
  fontSizeSelection: boolean;
};

export const editorConfig: EditorConfig = {
  height: '100%',
  pasteDeniedTags: ['img'],
  placeholderText: 'Write text here...',
  toolbarContainer: '#editor-froala-toolbar',
  charCounterCount: false,
  quickInsertEnabled: false,
  imageUpload: true,
  imageMaxSize: 5242880, // 5MB
  acceptedImageTypes: ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  shortcutsEnabled: ['show', 'bold', 'italic', 'underline', 'strikeThrough', 'indent', 'outdent', 'insertImage', 'createLink'],
  imageUploadURL: `${globalThis.env.VITE_API_ENDPOINT}${Endpoints.uploadImage}`,
  toolbarButtons: [
    '|',
    'paragraphFormat',
    'fontFamily',
    'bold',
    'italic',
    'underline',
    'textColor',
    'backgroundColor',
    'fontSize',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'formatUL',
    'formatOL',
    'lineHeight',
    'insertLink',
    // Hiding Image function as the layout is not fully functional
    // 'insertImage',
    'clearFormatting',
    '|',
    'chatGPT',
  ],
  paragraphFormatSelection: true,
  fontFamilySelection: true,
  attribution: false,
  fontSizeSelection: true,
  fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '24', '30', '32', '36', '48', '60', '72', '96'],
};

export const defaultFont = [
  { value: 'Georgia,serif', name: 'Georgia' },
  { value: 'Impact,Charcoal,sans-serif', name: 'Impact' },
  { value: 'Tahoma,Geneva,sans-serif', name: 'Tahoma' },
  { value: 'Verdana,Geneva,sans-serif', name: 'Verdana' },
  { value: "'Times New Roman',Times,serif", name: 'Times New Roman' },
];
